import get from './get';
export default (function (arr, key) {
  var existedKeys = {};
  return arr.filter(function (item) {
    var isExisted = existedKeys[get(item, key)];
    if (isExisted) return false;
    existedKeys[get(item, key)] = true;
    return true;
  });
});
//# sourceMappingURL=uniqBy.js.map